import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgShieldUser = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 5v6.1q0 3.825-2.175 6.9T12 22q-3.65-.925-5.825-4T4 11.1V5l8-3zm-8 10q-1.2 0-2.362.287-1.162.288-2.238.838.85 1.275 1.988 2.287A7.2 7.2 0 0 0 12 19.9a7.2 7.2 0 0 0 2.612-1.488 11.9 11.9 0 0 0 1.988-2.287 10.4 10.4 0 0 0-2.238-.838A9.8 9.8 0 0 0 12 15m0-9q-1.45 0-2.475 1.025A3.37 3.37 0 0 0 8.5 9.5q0 1.45 1.025 2.475A3.37 3.37 0 0 0 12 13q1.45 0 2.475-1.025A3.37 3.37 0 0 0 15.5 9.5q0-1.45-1.025-2.475A3.37 3.37 0 0 0 12 6" })
});
export default SvgShieldUser;
